import { Icon, Button, FormLayout, TextField, Tag, Autocomplete, ContextualSaveBar, BlockStack, Grid, Text, ButtonGroup, Divider, InlineStack, Checkbox, Box, Modal, Banner, TextContainer, InlineError, Select } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { RefreshMajor } from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../../Core';
import { Switch } from 'antd';
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';
import { getLastSyncInformation } from '../../ConfigHelper';
import { RenderSkeletonOrder } from '../../skeleton/skeleton';
import { useTranslation } from 'react-i18next';

const defaultOrderSettings = {
    "conditional_tags": {
        "enabled": false,
        "keys": {
            "FulfillmentChannel":
            {
                "enabled": true
            }
        }
    },
    "custom_shipping_details_method": {
        "enabled": false,
    },
    "fbo_order_first_name": "Customer",
    "fbo_order_last_name": "Customer",
    "fbo_order_fetch": false, //parent
    "fbo_order_sync": false, //child
    "order_shipping_tax": true,
    "order_id_format": {
        "prefix": "",
        "suffix": "",
    },
    "sync_cpf_number": false,
    "tags_in_order_enabled": false,
    "tagsInOrder": {
        "marketplace_reference_id": false,
        "seller_id": false,
        "marketplace": false,
        "custom": false,
    },
    "custom_tags_in_order": [],
    "custom_source_identifier": "Amazon",
    "order_sync": true,
    "order_for_product_not_existing": false,
    "source_marketplace_order_id_as_order_name": false,
    "email_on_failed_order": false,
    "order_item_tax": true,
    "fbo_order_import_cutoff_period": { "enabled": false, "period": "" }
}

const defaultErrors = {
    fbo_order_first_name: false,
    fbo_order_last_name: false,
    amazonCustomSourceIdentifier: false,
    customTag: false,
    tagsInOrder: false,
    preventOrderCreation: false
};
interface OrderProps extends DIProps {
    setOrderSettingsEnabled: (e: boolean) => void;
    saveLoader: boolean;
    setSaveLoader: (e: boolean) => void;
    getLoader: boolean;
    setGetLoader: (e: boolean) => void;
    showSkeleton: boolean;
    setShowSkeleton: (e: boolean) => void
}

function Order(props: OrderProps) {
    const { t } = useTranslation();
    const [isFreePlan, setFreePlan] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);
    const { showSkeleton, setShowSkeleton, saveLoader, setSaveLoader, getLoader, setGetLoader } = props;
    const [originalData, setOriginalData] = useState<any>(JSON.parse(JSON.stringify(defaultOrderSettings)));
    const [selectedTagOption, setSelectedtagOption] = useState<any>([]);
    const [valueTag, setValueTag] = useState('');
    const [tagOptions, setTagOptions] = useState<any>([]);
    const [errors, setErrors] = useState<any>(JSON.parse(JSON.stringify(defaultErrors)));
    const [showContextualSaveBar, setShowContextualSaveBar] = useState<boolean>(false);
    const [preparedData, setPreparedData] = useState<any>(JSON.parse(JSON.stringify(defaultOrderSettings)));
    const [lastSync, setLastSync] = useState('');
    const [confirmSave, setConfirmSave] = useState(false);
    const [savedFBOSetting, setSavedFBOSetting] = useState<boolean>(false);

    const handleSettingsEnableOrDisable = (e: boolean) => {
        handleData("order_sync", "", e)
        if (!e) {
            removeAllErrorsWhileResetting()
        }
    }

    const handleData = (key: string, subkey: string, value: any) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        if (subkey != "") {
            if (key == "custom_shipping_details_method" || "conditional_tags") {
                tempPreparedData[key] = {
                    ...tempPreparedData[key],
                    [subkey]: value
                }
            }
            else tempPreparedData[key][subkey] = value;
        }
        else {
            if (isFreePlan && key == 'fbo_order_fetch' && !value) {
                setOpenModal(true);
            }
            else tempPreparedData[key] = value
        }
        setPreparedData(JSON.parse(JSON.stringify(tempPreparedData)));
    }

    const removeTag = (tag: string, index: number) => () => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        tempPreparedData.custom_tags_in_order.splice(index, 1);
        setPreparedData({ ...tempPreparedData });
    }

    const tagMarkup = preparedData.custom_tags_in_order.map((option: string, index: number) => (
        <Tag key={option} onRemove={removeTag(option, index)}>
            {option}
        </Tag>
    ));

    const getLastOrderSyncDate = () => {
        let data = getLastSyncInformation(props, 'order');
        data.then((res: any) => {
            if (res?.error) props.error(t(res?.error) ?? '');
            else setLastSync(res?.date ?? '')
        })
    }

    const removeStaleValues = (obj: any) => {
        let updatedData: any = JSON.parse(JSON.stringify(obj));
        if (!updatedData.order_sync) {
            updatedData = JSON.parse(JSON.stringify({ ...defaultOrderSettings, ...obj }));
            updatedData['order_sync'] = !updatedData.hasOwnProperty('order_sync') ? true : updatedData.order_sync;
        }
        else {
            if (!updatedData?.tags_in_order_enabled) {
                updatedData = {
                    ...updatedData,
                    tagsInOrder: JSON.parse(JSON.stringify(defaultOrderSettings.tagsInOrder)),
                    custom_tags_in_order: JSON.parse(JSON.stringify(defaultOrderSettings.custom_tags_in_order))
                }
            } else {
                if (!updatedData?.tagsInOrder.custom)
                    updatedData = { ...updatedData, custom_tags_in_order: JSON.parse(JSON.stringify(defaultOrderSettings.custom_tags_in_order)) }
            }
            if (!updatedData?.source_marketplace_order_id_as_order_name) {
                updatedData = {
                    ...updatedData, order_id_format: {
                        prefix: JSON.parse(JSON.stringify(defaultOrderSettings.order_id_format.prefix)),
                        suffix: JSON.parse(JSON.stringify(defaultOrderSettings.order_id_format.suffix))
                    }
                }
            }
            if (!updatedData?.fbo_order_sync) {
                updatedData = {
                    ...updatedData, fbo_order_first_name: JSON.parse(JSON.stringify(defaultOrderSettings.fbo_order_first_name)),
                    fbo_order_last_name: JSON.parse(JSON.stringify(defaultOrderSettings.fbo_order_last_name))
                }
            }
        }
        return updatedData;
    }

    const getOrderSettings = () => {
        setGetLoader(true)
        props.di.POST('connector/config/getConfig', {
            "group_code": ["order"]
        }).then((response: any) => {
            setGetLoader(false)
            setShowSkeleton(false);
            if (response?.success) {
                if (response?.data?.[0]?.group_code == "order" && response?.data?.[0]?.value && Object.keys(response?.data?.[0]?.value).length > 0) {
                    let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
                    let receivedData: any = removeStaleValues(JSON.parse(JSON.stringify(response?.data?.[0]?.value)));
                    let tempErrors = JSON.parse(JSON.stringify(defaultErrors));

                    if (receivedData.hasOwnProperty('order_id_format')) {
                        tempPreparedData['order_id_format'] = receivedData['order_id_format'];
                    }
                    if (receivedData.hasOwnProperty('custom_shipping_details_method')) {
                        tempPreparedData['custom_shipping_details_method'] = receivedData['custom_shipping_details_method'];
                    }
                    if (receivedData.hasOwnProperty('conditional_tags')) {
                        tempPreparedData['conditional_tags'] = receivedData['conditional_tags'];
                    }
                    if (receivedData.hasOwnProperty('sync_cpf_number')) {
                        tempPreparedData['sync_cpf_number'] = receivedData['sync_cpf_number'];
                    }
                    if (receivedData.hasOwnProperty('tags_in_order_enabled')) {
                        tempPreparedData['tags_in_order_enabled'] = receivedData['tags_in_order_enabled'];
                    }
                    if (receivedData.hasOwnProperty('tagsInOrder')) {
                        tempPreparedData['tagsInOrder'] = receivedData['tagsInOrder'];
                    }
                    if (receivedData.hasOwnProperty('custom_tags_in_order')) {
                        tempPreparedData['custom_tags_in_order'] = receivedData['custom_tags_in_order'];
                    }
                    if (receivedData.hasOwnProperty('custom_source_identifier')) {
                        tempPreparedData['custom_source_identifier'] = receivedData['custom_source_identifier'];
                    }
                    if (receivedData.hasOwnProperty('order_sync')) {
                        tempPreparedData['order_sync'] = receivedData['order_sync'];
                    }
                    if (receivedData.hasOwnProperty('order_for_product_not_existing')) {
                        tempPreparedData['order_for_product_not_existing'] = receivedData['order_for_product_not_existing'];
                    }
                    if (receivedData.hasOwnProperty('source_marketplace_order_id_as_order_name')) {
                        tempPreparedData['source_marketplace_order_id_as_order_name'] = receivedData['source_marketplace_order_id_as_order_name'];
                    }
                    if (receivedData.hasOwnProperty('email_on_failed_order')) {
                        tempPreparedData['email_on_failed_order'] = receivedData['email_on_failed_order'];
                    }
                    if (receivedData.hasOwnProperty('order_item_tax')) {
                        tempPreparedData['order_item_tax'] = receivedData['order_item_tax'];
                    }
                    if (receivedData.hasOwnProperty('order_shipping_tax')) {
                        tempPreparedData['order_shipping_tax'] = receivedData['order_shipping_tax'];
                    }
                    if (receivedData.hasOwnProperty('fbo_order_fetch')) {
                        tempPreparedData['fbo_order_fetch'] = receivedData['fbo_order_fetch'];
                        setSavedFBOSetting(receivedData['fbo_order_fetch']);
                    }
                    if (receivedData.hasOwnProperty('fbo_order_sync')) tempPreparedData['fbo_order_sync'] = receivedData['fbo_order_sync'];
                    if (receivedData.hasOwnProperty('fbo_order_first_name')) tempPreparedData['fbo_order_first_name'] = receivedData['fbo_order_first_name'];
                    if (receivedData.hasOwnProperty('fbo_order_last_name')) tempPreparedData['fbo_order_last_name'] = receivedData['fbo_order_last_name'];
                    if (receivedData.hasOwnProperty('fbo_order_import_cutoff_period')) {
                        tempPreparedData['fbo_order_import_cutoff_period'] = receivedData['fbo_order_import_cutoff_period'];
                    }
                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                    setOriginalData(JSON.parse(JSON.stringify(tempPreparedData)));
                    setPreparedData(JSON.parse(JSON.stringify(tempPreparedData)));
                    props.setOrderSettingsEnabled(receivedData?.order_sync ?? defaultOrderSettings.order_sync)
                }
            }
            else {
                props.error(t("Oops! Some error occured while getting order settings."));
            }
        });
    }

    const checkFreePlan = () => {
        const isFreePlan = (props.redux.current_plan?.plan_details?.title === 'Free' || props.redux.current_plan?.plan_details?.title === 'Trial') && (props.redux.current_plan?.plan_details?.custom_price == 0);
        setFreePlan(isFreePlan);
    }

    useEffect(() => {
        checkFreePlan();
        setShowSkeleton(true);
        getOrderSettings();
        getLastOrderSyncDate();
    }, []);

    useEffect(() => {
        if (Object.keys(preparedData).length > 0) {
            if (JSON.stringify(originalData) != JSON.stringify(removeStaleValues(preparedData))) setShowContextualSaveBar(true);
            else setShowContextualSaveBar(false);
        }
    }, [preparedData])

    const updateTagText = (value: string) => {
        setValueTag(value);
        if (value === "") {
            setTagOptions([]);
            return;
        }

        const filterRegex = new RegExp(value, "i");
        const resultOptions = [{ value: `${t("Add")} '${value}'`, label: `${t("Add")} '${value}'` }].filter((option) =>
            option.label.match(filterRegex)
        );
        setTagOptions(resultOptions);
    }

    const updateTagSelection = (selected: any) => {
        const selectedValue = selected.map((selectedItem: any) => {
            const matchedOption = tagOptions.find((option: any) => {
                return option.value.match(selectedItem);
            });
            return matchedOption && matchedOption.label;
        });
        if (preparedData.custom_tags_in_order.length <= 1 && valueTag != "" && valueTag.trim().length != 0) {
            preparedData.custom_tags_in_order.push(valueTag);
            setPreparedData(JSON.parse(JSON.stringify(preparedData)));
            let tempErrors = JSON.parse(JSON.stringify(errors))
            tempErrors.customTag = preparedData.custom_tags_in_order.length <= 0
            setErrors(JSON.parse(JSON.stringify(tempErrors)));
        }
        setSelectedtagOption(selectedValue);
        setTagOptions([]);
        setValueTag("");
    }

    function handleKeyPress(e: any) {
        let keyCode = e.keyCode
        if (keyCode == 13) {
            updateTagSelection([valueTag])
            setTagOptions([]);
        }
    }

    const tagsTextField = (
        <span onKeyDown={(e) => handleKeyPress(e)}>
            <Autocomplete.TextField
                onChange={updateTagText}
                label={t("Tags")}
                value={valueTag}
                placeholder={t(`Press 'Enter' to add tag`)}
                autoComplete='off'
                disabled={preparedData.custom_tags_in_order.length == 2 || !preparedData.order_sync || saveLoader || getLoader || !preparedData.tags_in_order_enabled || !preparedData.tagsInOrder.custom}
                error={errors.customTag}
                helpText={t('Only two custom tags are permitted.')}
            />
        </span>
    );

    const validator = () => {
        let hasError = false;
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (preparedData.order_sync) {
            if (preparedData.tags_in_order_enabled) {
                let areAllFalse: boolean = false;
                areAllFalse = Object.values(preparedData.tagsInOrder).every(value => value === false);
                if (areAllFalse) {
                    hasError = true;
                    tempErrors.tagsInOrder = true;
                }
                else tempErrors.tagsInOrder = false;
            }
            if (preparedData.tags_in_order_enabled && preparedData.tagsInOrder.custom) {
                if (preparedData.custom_tags_in_order.length <= 0) {
                    hasError = true;
                    tempErrors.customTag = preparedData.custom_tags_in_order.length <= 0;
                }
            }
            if (preparedData.custom_source_identifier == '' || preparedData.custom_source_identifier.trim().length == 0) {
                hasError = true;
                tempErrors.amazonCustomSourceIdentifier = preparedData.custom_source_identifier == '' || preparedData.custom_source_identifier.trim().length == 0;
            }
            if (preparedData.fbo_order_sync) {
                if (preparedData.fbo_order_first_name.trim() == '') {
                    hasError = true;
                    tempErrors.fbo_order_first_name = preparedData.fbo_order_first_name.trim() == '';
                }
                if (preparedData.fbo_order_last_name.trim() == '') {
                    hasError = true;
                    tempErrors.fbo_order_last_name = preparedData.fbo_order_last_name.trim() == '';
                }
            }
            if (preparedData.fbo_order_import_cutoff_period.enabled) {
                if (preparedData.fbo_order_import_cutoff_period.period == "") {
                    hasError = true;
                    tempErrors.preventOrderCreation = true;
                }
            }
        }
        return { hasError, tempErrors };
    }

    function filterEditedData(original: any, changed: any) {
        const allSettings = Object.keys(JSON.parse(JSON.stringify(defaultOrderSettings)));
        const myObj: any = {};
        allSettings.forEach((setting: string) => {
            if (JSON.stringify(changed[setting]) != JSON.stringify(original[setting])) {
                myObj[setting] = changed[setting];
            }
        });
        return myObj;
    }

    const prepareBackendData = () => {
        let tempPreparedData = removeStaleValues(JSON.parse(JSON.stringify(preparedData)));
        if (tempPreparedData.source_marketplace_order_id_as_order_name) {
            if (tempPreparedData?.order_id_format?.prefix.trim().length == 0) {
                tempPreparedData.order_id_format.prefix = '';
            }
            if (tempPreparedData?.order_id_format?.suffix.trim().length == 0) {
                tempPreparedData.order_id_format.suffix = '';
            }
        }
        tempPreparedData['custom_source_identifier'] = tempPreparedData['custom_source_identifier'].trim();
        if (!tempPreparedData['fbo_order_import_cutoff_period']['enabled']) tempPreparedData['fbo_order_import_cutoff_period']['period'] = ""
        const editedData = filterEditedData(originalData, tempPreparedData);

        let backendData = [
            {
                data: JSON.parse(JSON.stringify(editedData)),
                group_code: "order"
            }
        ];
        setPreparedData({ ...tempPreparedData })
        return backendData;
    }

    const handleDiscardBtn = () => {
        setErrors(JSON.parse(JSON.stringify(defaultErrors)));
        setShowSkeleton(true);
        setShowContextualSaveBar(false);
        setPreparedData(JSON.parse(JSON.stringify(defaultOrderSettings)));
        setValueTag('');
        setTagOptions([]);
        getOrderSettings();
        getLastOrderSyncDate();
    }

    const syncFbaUserstoDynamo = () => {
        props.di.POST('amazon/request/syncFbaUserstoDynamo', {
            key: 'fbo_order_fetch',
            value: preparedData['fbo_order_fetch']
        })
            .then((response: any) => {
                if (!response?.success)
                    props?.error(response?.message)
            })
    }

    const handleSave = () => {
        setSaveLoader(true);
        const { hasError, tempErrors: receivedErrors } = validator();
        if (!hasError) {
            let backendData = prepareBackendData();
            props.di.POST('connector/config/saveConfig', {
                "data": backendData
            }).then((response: any) => {
                setShowContextualSaveBar(false);
                setSaveLoader(false);
                if (response?.success) {
                    props.success(t("Order settings saved successfully."));
                    // if (backendData?.[0]?.data?.fbo_order_fetch && backendData?.[0]?.data?.fbo_order_fetch != savedFBOSetting) {
                    syncFbaUserstoDynamo();
                    // }
                }
                else {
                    props.error(t(response?.message) ?? t("Oops! Some error occured while saving."));
                }
                getLastOrderSyncDate();
                getOrderSettings();
            })
        }
        else {
            props.error(t("Some information is missing or wrong, kindly check them before proceeding."));
            setSaveLoader(false);
            setErrors(JSON.parse(JSON.stringify(receivedErrors)));
        }
    }

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        let savebar_options: any = {
            loading: saveLoader,
        };
        if (showContextualSaveBar) {

            if (preparedData.order_sync)
                showSaveBar(handleDiscardBtn, handleSave, { ...savebar_options });
            else showSaveBar(handleDiscardBtn, () => setConfirmSave(true), { ...savebar_options });
        } else hideSaveBar();
    }

    // To remove Errors while resetting indivisually
    const removeErrors = (key: string) => {
        let tempErrors = JSON.parse(JSON.stringify(errors))
        if (key === "") {
            if (tempErrors?.customTag) {
                tempErrors.customTag = false;
            }
        }
        else {
            tempErrors?.[key]?.map((obj: any) => {
                if (obj.amazon || obj.shopify) {
                    obj.amazon = false;
                    obj.shopify = false;
                }
            });
        }
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }

    // To remove all the errors while resetting
    const removeAllErrorsWhileResetting = () => {
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (tempErrors?.amazonCustomSourceIdentifier) {
            tempErrors.amazonCustomSourceIdentifier = false;
        }
        if (tempErrors?.customTag) {
            tempErrors.customTag = false;
        }
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }

    const redirectToChoosePlan = () => {
        props.history('../../home/pricing', {
            replace: false,
            state: {
                plan_name: props.redux.current_plan?.plan_details?.title,
                billed_type: props.redux.current_plan?.plan_details?.billed_type,
                category: props.redux.current_plan?.plan_details?.category
            }
        });
    }

    return (
        showSkeleton ? RenderSkeletonOrder() :
            <>
                {showContextualSaveBar && (process.env.REACT_APP_PROD === "0" ||
                    isAdminLoggedIn()) && (
                        <ContextualSaveBar
                            message="Unsaved changes"
                            saveAction={{
                                onAction: () => {
                                    if (preparedData.order_sync)
                                        handleSave();
                                    else setConfirmSave(true)
                                },
                                loading: saveLoader,
                            }}
                            discardAction={{
                                disabled: saveLoader,
                                onAction: () => { handleDiscardBtn() },
                            }}
                        />
                    )}
                <Modal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    title={t("Upgrade plan to disable FBA Order Sync on Shopify")}
                    primaryAction={{
                        content: t('Upgrade Plan'),
                        onAction: redirectToChoosePlan,
                    }}
                    secondaryActions={[
                        {
                            content: t('Close'),
                            onAction: () => setOpenModal(false),
                        },
                    ]}
                >
                    <Modal.Section>
                        <Text as='p'>
                            <Text as='span' fontWeight='semibold'>{t("Please Note:")}</Text> {t("You cannot disable the setting for FBA order synchronization on Shopify yet as you are on a free plan. Access this feature by upgrading to a paid plan.")}
                        </Text>
                    </Modal.Section>
                </Modal>
                <Modal title={t('Confirm Save')} primaryAction={{
                    onAction: () => {
                        handleSave();
                        setConfirmSave(false);
                    },
                    content: t('Save'),
                    loading: saveLoader,
                }} secondaryActions={[{
                    onAction: () => { setConfirmSave(false) },
                    content: t('Cancel'),
                    disabled: saveLoader
                }]} open={confirmSave} onClose={() => { setConfirmSave(false) }}>
                    <Modal.Section>
                        <Text as='p'>{t("Since order syncing is disabled, inventory will not be decreased on your Shopify Store when orders come from Amazon.")}</Text>
                    </Modal.Section>
                </Modal>
                <BlockStack gap="500">
                    <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} >
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }} >
                            <BlockStack gap="200">
                                <Text variant="headingMd" as="h6" id='order_Text_OrderSettings'>
                                    {t("Order")}
                                </ Text>
                                <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_OrderSettingsDescription'>
                                    {t("Manage or edit settings related to your Amazon orders and how you wish to process them on your Shopify store. By default, only FBM orders will be created on Shopify.")}
                                </Text>
                            </BlockStack>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <div className='Custom__Button--Alignment'>
                                <ButtonGroup variant='segmented'>
                                    <Button id='order_Btn_Enable' disabled={saveLoader || getLoader} pressed={preparedData.order_sync} onClick={() => handleSettingsEnableOrDisable(true)}>{t("Enabled")}</Button>
                                    <Button id='order_Btn_Disable' disabled={saveLoader || getLoader} pressed={!preparedData.order_sync || saveLoader || getLoader} onClick={() => handleSettingsEnableOrDisable(false)}>{t("Disabled")}</Button>
                                </ButtonGroup>
                            </div>
                        </Grid.Cell>
                    </Grid>
                    {preparedData.order_sync && <Banner tone={'info'}>
                        {t("Whenever a setting is saved, such as 'create an order for a non-existing product' or 'sync a shipment without tracking details,' it only applies to new orders or shipments. It doesn't affect existing or past orders. Past orders will continue to follow the previously established settings.")}
                    </Banner>}
                    {!preparedData.order_sync && <Banner tone='warning'>
                        {t("Since order syncing is disabled, inventory will not be decreased on your Shopify Store when orders come from Amazon.")}
                    </Banner>}
                    <Divider />
                    <BlockStack gap="800">
                        <BlockStack gap="500">
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='order_Switch_CreateOrderForNonExistingProducts' size='small' onChange={(e: boolean) => handleData("order_for_product_not_existing", "", e)} checked={preparedData.order_for_product_not_existing} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                                <BlockStack gap="100">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='order_Text_CreateOrderForNonExistingProducts'>
                                            {t("Sync Amazon orders for not-linked products")}
                                        </Text>
                                    </div>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_CreateOrderForNonExistingProductsDescription'>
                                        {t("By enabling this, you ensure that orders placed on Amazon for those products that require linking in the app are also synched with Shopify.")}
                                    </Text>
                                </BlockStack>
                            </InlineStack>
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='order_Switch_AmazonItemTax' size='small' onChange={(e: boolean) => handleData("order_item_tax", "", e)} checked={preparedData.order_item_tax} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                                <BlockStack gap="100">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='order_Text_AmazonItemTax'>
                                            {t("Display Item Tax break-up")}
                                        </Text>
                                    </div>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_AmazonItemTaxDescription'>
                                        {t("By enabling this option, you can display a price breakdown that includes item taxes from Amazon orders in Shopify. However, the taxes for the orders will not be synced.")}
                                    </Text>
                                </BlockStack>
                            </InlineStack>
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='order_Switch_AmazonShippingTax' size='small' onChange={(e: boolean) => handleData("order_shipping_tax", "", e)} checked={preparedData.order_shipping_tax} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                                <BlockStack gap="100">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='order_Text_AmazonShippingTax'>
                                            {t("Display Shipping Tax break-up")}
                                        </Text>
                                    </div>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_AmazonShippingTaxDescription'>
                                        {t("By enabling this option, you can display a price breakdown that includes shipping taxes from Amazon orders in Shopify. However, the taxes for the orders will not be synced.")}
                                    </Text>
                                </BlockStack>
                            </InlineStack>
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='order_Switch_FBOOrderFetch' size='small' onChange={(e: boolean) => handleData("fbo_order_fetch", "", e)} checked={preparedData.fbo_order_fetch || isFreePlan} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                                <BlockStack gap="200">
                                    <BlockStack gap="100">
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='order_Text_AmazonShippingTax'>
                                                {t("Sync FBA orders from Amazon to app")}
                                            </Text>
                                        </div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_AmazonShippingTaxDescription'>
                                            {t("Enabling this setting will synchronize FBA orders from Amazon to our app.")}
                                        </Text>
                                    </BlockStack>
                                    <div className={preparedData.fbo_order_fetch || isFreePlan ? undefined : 'card_dull'}>
                                        <InlineStack gap="200" wrap={false}>
                                            <Switch className='switcherBtn' size='small' onChange={(e: boolean) => handleData("fbo_order_sync", "", e)} checked={preparedData.fbo_order_sync} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                                            <BlockStack gap="200">
                                                <BlockStack gap="100">
                                                    <div className='Custom__Line--Height'>
                                                        <Text variant="headingSm" as="h6">
                                                            {t("Sync FBA orders from app to Shopify")}
                                                        </Text>
                                                    </div>
                                                    <Text as="p" fontWeight="regular" tone='subdued'>
                                                        {t("Send FBA orders on Shopify to manage product information.")}
                                                    </Text>
                                                </BlockStack>
                                                <BlockStack gap="100">
                                                    <Text variant="headingSm" as="h6">
                                                        {t("Add customer details")}
                                                    </Text>
                                                    <Text as="p" fontWeight="regular" tone='subdued'>
                                                        {t("By default, when processing orders on Shopify, the customer name sent will be set as 'Customer.' However, it is important to note that customer details can be customised for FBA orders to ensure accurate and relevant information.")}
                                                    </Text>
                                                </BlockStack>
                                                <div className='Custom__TextField--alignmnet'>
                                                    <FormLayout>
                                                        <FormLayout.Group condensed>
                                                            <TextField label={t("First Name")} value={preparedData.fbo_order_first_name ?? ''}
                                                                onChange={(e: any) => {
                                                                    e = e.toString().replace(/[!$%^&*()@+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                                                                    e = e.toString().replace("  ", " ");
                                                                    handleData("fbo_order_first_name", "", e)
                                                                    let tempErrors = JSON.parse(JSON.stringify(errors));
                                                                    tempErrors['fbo_order_first_name'] = e.trim() == '';
                                                                    setErrors(JSON.parse(JSON.stringify(tempErrors)))
                                                                }}
                                                                autoComplete="off"
                                                                placeholder={t(`Customer`)}
                                                                error={errors.fbo_order_first_name}
                                                                disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.fbo_order_sync}
                                                            />
                                                            <TextField label={t("Last Name")} value={preparedData?.fbo_order_last_name ?? ''}
                                                                onChange={(e: any) => {
                                                                    e = e.toString().replace(/[!$%^&*()@+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                                                                    e = e.toString().replace("  ", " ");
                                                                    handleData("fbo_order_last_name", "", e)
                                                                    let tempErrors = JSON.parse(JSON.stringify(errors));
                                                                    tempErrors['fbo_order_last_name'] = e.trim() == '';
                                                                    setErrors(JSON.parse(JSON.stringify(tempErrors)))
                                                                }}
                                                                autoComplete="off"
                                                                placeholder={t(`Customer`)}
                                                                error={errors.fbo_order_last_name}
                                                                disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.fbo_order_sync}
                                                            />
                                                        </FormLayout.Group>
                                                    </FormLayout>
                                                </div>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                </BlockStack>
                            </InlineStack>

                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='order_Switch_SyncCPFNumber' size='small' onChange={(e: boolean) => handleData("sync_cpf_number", "", e)} checked={preparedData.sync_cpf_number} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                                <BlockStack gap="100">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='order_Text_SyncCPFNumber'>
                                            {t("Sync CPF Number")}
                                        </Text>
                                    </div>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_SyncCPFNumberDescription'>
                                        {t(`Please Note: CPF (Cadastro de Pessoas Físicas, Portuguese for 'Natural Persons Register') is the Brazilian National ID and is mandatory to make any International sales to Brazilian citizens due to customs. You can enable this if it applies to your case.`)}
                                    </Text>
                                </BlockStack>
                            </InlineStack>
                        </BlockStack>
                        <Box paddingInlineStart="300" paddingInlineEnd="300" paddingBlockEnd="200" paddingBlockStart="200" background='bg-surface-disabled'>
                            <Text variant="headingSm" as="h6" tone='subdued' id='order_Text_IDENTIFYAMAZONORDERSONSHOPIFY'>
                                {t("CREATE AMAZON ORDER IDENTIFIERS ON SHOPIFY")}
                            </Text>
                        </Box>
                    </BlockStack>

                    <InlineStack gap="200" wrap={false}>
                        <Switch className='switcherBtn' size='small' checked={preparedData.custom_shipping_details_method.enabled} id='order_Switch_AutomatedShippingSettings' onChange={(e: boolean) => handleData("custom_shipping_details_method", "enabled", e)} />
                        <BlockStack gap="300">
                            <BlockStack gap="100">
                                <div className='Custom__Line--Height'>
                                    <Text variant="headingSm" as="h6" id='order_Text_AutomatedShippingSettings'>
                                        {t("Automated Shipping Settings")}
                                    </Text>
                                </div>
                                <Text as='p' fontWeight="regular" tone='subdued'>{t("Enable this to sync information regarding the Shipping Settings Automation program, such as whether the order's shipping settings were generated automatically, and what those settings are.")}</Text>
                                <Text as='p' fontWeight="semibold" tone='subdued' variant='bodyMd'>{t("Note: only synced when provided by Amazon")}</Text>
                            </BlockStack>
                        </BlockStack>
                    </InlineStack>

                    <InlineStack gap="200" wrap={false}>
                        <Switch className='switcherBtn' size='small' defaultChecked disabled id='order_Switch_OrderSourceIdentifier' />
                        <BlockStack gap="300">
                            <BlockStack gap="100">
                                <div className='Custom__Line--Height'>
                                    <Text variant="headingSm" as="h6" id='order_Text_OrderSourceIdentifier'>
                                        {t("Order source identifier")}
                                    </Text>
                                </div>
                                {/* <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_OrderSourceIdentifierDescription'>
                                    Identify source of orders on Shopify. By default, Amazon tag will be added.
                                </Text> */}
                                <Text as='p' fontWeight="regular" tone='subdued'>{t("The channel of all your orders will only be labeled as 'Amazon' on the Shopify order section, as Shopify no longer supports the order source identifier functionality.")}</Text>
                                <Text as='p' fontWeight="semibold" tone='subdued' variant='bodyMd'>{t("Note: This setting cannot be changed.")}</Text>
                            </BlockStack>
                            <div className='Custom__TextField--alignmnet'>
                                <TextField id='order_TextField_OrderSourceIdentifier' label="" value={preparedData.custom_source_identifier}
                                    onChange={(e: any) => {
                                        handleData("custom_source_identifier", "", e)
                                        let tempErrors = JSON.parse(JSON.stringify(errors));
                                        if (e == '' || e.trim().length == 0) {
                                            tempErrors.amazonCustomSourceIdentifier = e == '' || e.trim().length == 0
                                        }
                                        else {
                                            tempErrors.amazonCustomSourceIdentifier = e == '' || e.trim().length == 0
                                        }
                                        setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                    }}
                                    error={errors.amazonCustomSourceIdentifier}
                                    // disabled={!preparedData.order_sync || saveLoader || getLoader}
                                    disabled
                                    autoComplete="off" placeholder={t('Amazon')} />
                            </div>
                        </BlockStack>
                    </InlineStack>
                    <InlineStack gap="200" wrap={false}>
                        <Switch className='switcherBtn' id='order_Switch_AddTagsInOrder' size='small' onChange={(e: boolean) => {
                            handleData("tags_in_order_enabled", "", e)
                            if (e == false) removeErrors("");
                        }}
                            checked={preparedData.tags_in_order_enabled}
                            disabled={!preparedData.order_sync || saveLoader || getLoader} />
                        <BlockStack gap="200">
                            <BlockStack gap="100">
                                <div className='Custom__Line--Height'>
                                    <Text variant="headingSm" as="h6" id='order_Text_AddTagsInOrder'>
                                        {t("Add Tags in Order")}
                                    </Text>
                                </div>
                                <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_AddTagsInOrderDescription'>
                                    {t("You can either select from these options to label your orders or add your own unique tag.")}
                                </Text>
                            </BlockStack>
                            <BlockStack gap="200">
                                <BlockStack gap="0">

                                    <Checkbox
                                        id='order_Checkbox_AmazonOrderID'
                                        label={t("Amazon order ID")}
                                        onChange={(e: boolean) => handleData("tagsInOrder", "marketplace_reference_id", e)} checked={preparedData.tagsInOrder.marketplace_reference_id}
                                        disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.tags_in_order_enabled}
                                    />
                                    <Checkbox
                                        id='order_Checkbox_SellerID'
                                        label={t("Seller ID")}
                                        onChange={(e: boolean) => handleData("tagsInOrder", "seller_id", e)}
                                        checked={preparedData.tagsInOrder.seller_id}
                                        disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.tags_in_order_enabled}
                                    />
                                    <Checkbox
                                        id='order_Checkbox_Amazon'
                                        label={t("Amazon")}
                                        onChange={(e: boolean) => handleData("tagsInOrder", "marketplace", e)}
                                        checked={preparedData.tagsInOrder.marketplace}
                                        disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.tags_in_order_enabled}
                                    />
                                    <Checkbox
                                        id='order_Checkbox_FulfillmentChannel(FBA/FBM)'
                                        label={t("Fulfillment Channel(FBA/FBM)")}
                                        onChange={(e: boolean) => handleData("conditional_tags", "enabled", e)} checked={preparedData.conditional_tags.enabled}
                                        disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.tags_in_order_enabled}
                                    />
                                    <Checkbox
                                        id='order_Checkbox_SetCustomTag'
                                        label={t("Choose Custom Tag")}
                                        onChange={(e: boolean) => {
                                            handleData("tagsInOrder", "custom", e);
                                            if (e == false) removeErrors("")
                                        }}
                                        checked={preparedData.tagsInOrder.custom}
                                        disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.tags_in_order_enabled}
                                    />
                                </BlockStack>
                                <div className='Custom__TextField--alignmnet'>
                                    <Autocomplete
                                        id='order_Autocomplete_Tags'
                                        options={tagOptions}
                                        selected={selectedTagOption}
                                        textField={tagsTextField}
                                        onSelect={updateTagSelection}
                                    />
                                    <InlineStack gap="200">{preparedData.tagsInOrder.custom && <div className={!preparedData?.order_sync || !preparedData.tags_in_order_enabled ? "card_dull" : undefined}>{tagMarkup}</div>}</InlineStack>
                                </div>
                            </BlockStack>
                            {errors.tagsInOrder && <InlineError fieldID='inlineErrortagsInOrder' message={t("Please select at least one tag or create a custom one to proceed.")} />}
                        </BlockStack >
                    </InlineStack >
                    <InlineStack gap="200" wrap={false}>
                        <Switch className='switcherBtn' id='order_Switch_ModifyShopifyOrderName' size='small' onChange={(e: boolean) => handleData("source_marketplace_order_id_as_order_name", "", e)} checked={preparedData.source_marketplace_order_id_as_order_name} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                        <BlockStack gap="300">
                            <BlockStack gap="100">
                                <div className='Custom__Line--Height'>
                                    <Text variant="headingSm" as="h6" id='order_Text_ModifyShopifyOrderName'>
                                        {t("Modify Shopify order name")}
                                    </Text>
                                </div>
                                <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ModifyShopifyOrderNameDescription'>
                                    {t("Use Amazon Order IDs on Shopify for easy identification of Amazon orders.")}
                                </Text>
                            </BlockStack>
                            <BlockStack gap="200">
                                <BlockStack gap="100">
                                    <Text variant="headingSm" as="h6" id='order_Text_EditShopifyOrderName'>
                                        {t("Edit Shopify Order Name (Optional)")}
                                    </Text>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_EditShopifyOrderNameDescription'>
                                        {t("Easily modify order names and details here. Note that every order begins with the default Order Number #1001. Although the order number can't be altered, you can attach a prefix or suffix to generate IDs like 'EN1001-A'.")}
                                    </Text>
                                </BlockStack>
                                <div className='Custom__TextField--alignmnet'>
                                    <FormLayout>
                                        <FormLayout.Group condensed>
                                            <TextField label={t("Prefix")}
                                                id='order_TextField_Prefix'
                                                value={preparedData.order_id_format.prefix}
                                                onChange={(e: any) => handleData("order_id_format", "prefix", e)}
                                                autoComplete="off"
                                                placeholder={t(`Choose suitable prefix`)}
                                                disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.source_marketplace_order_id_as_order_name} />
                                            <TextField label={t("Suffix")} value={preparedData.order_id_format.suffix}
                                                id='order_TextField_Suffix'
                                                onChange={(e: any) => handleData("order_id_format", "suffix", e)}
                                                autoComplete="off"
                                                placeholder={t(`Choose suitable suffix`)}
                                                disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.source_marketplace_order_id_as_order_name} />
                                        </FormLayout.Group>
                                    </FormLayout>
                                </div>
                            </BlockStack >
                        </BlockStack >
                    </InlineStack >
                    <InlineStack gap="200" wrap={false}>
                        <Switch className='switcherBtn' id='preventOrderCancelation' size='small' onChange={(e: boolean) => {
                            handleData("fbo_order_import_cutoff_period", "enabled", e);
                            setErrors((prev: any) => {
                                return {
                                    ...prev,
                                    preventOrderCreation: e == false && false
                                }
                            });
                        }} checked={preparedData.fbo_order_import_cutoff_period.enabled} disabled={!preparedData.order_sync || saveLoader || getLoader} />
                        <BlockStack gap="200">
                            <div className='Custom__Line--Height'>
                                <Text variant="headingSm" as="h6" id='cancellationAndRefund_Text_SyncCancelledOrdersOnShopify'>
                                    {"Restrict Old FBA Orders"}
                                </Text>
                            </div>
                            <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ModifyShopifyOrderNameDescription'>
                                {t("Set a time limit to prevent older Amazon FBA orders from being imported into the app. For example, if you set it to 3 months and import orders on April 10th, only FBA orders created on or after January 10th will be imported. Orders created before this date will be skipped.")}
                            </Text>
                            <Select label={t("Restrict FBA orders older than")} disabled={!preparedData.order_sync || saveLoader || getLoader || !preparedData.fbo_order_import_cutoff_period.enabled} error={errors.preventOrderCreation} onChange={(e) => {
                                handleData("fbo_order_import_cutoff_period", "period", e);
                                setErrors((prev: any) => {
                                    return {
                                        ...prev,
                                        preventOrderCreation: e == ""
                                    }
                                });
                            }} value={preparedData.fbo_order_import_cutoff_period.period} options={[
                                {
                                    label: t("Select time period"), value: ""
                                }, {
                                    label: t("3 Months"), value: "-3 months"
                                },
                                {
                                    label: t("6 Months"), value: "-6 months"
                                },
                                {
                                    label: t("1 Year"), value: "-1 year"
                                }]}></Select>
                        </BlockStack>
                    </InlineStack>
                    {lastSync && <>
                        <Divider />
                        <InlineStack blockAlign='center' align='space-between' gap="200">
                            <div className='Custom__Sync--Update'>
                                <InlineStack gap="200" wrap={false}>
                                    <div>
                                        <Icon source={RefreshMajor} tone="base" />
                                    </div>
                                    <Text variant="headingSm" as="h6" tone='subdued'>
                                        {t("Last updated")}: {lastSync}
                                    </Text>
                                </InlineStack>
                            </div>
                        </InlineStack>
                    </>
                    }
                </BlockStack >
            </>
    );
};
export default DI(Order);